import { categoriesMock, buildProductsSearchMockResponse } from "../../../mocks/productsSearchMock";

export const mockProductsProvider = {
  productsSearch: async (data, _requestConfig) => {
    const responseData = buildProductsSearchMockResponse(data);
    return Promise.resolve({
      status: 200,
      data: responseData,
    });
  },

  categorie: async () => {
    return Promise.resolve({
      status: 200,
      data: categoriesMock,
    });
  },
};
